import { render, staticRenderFns } from "./sorting-control.vue?vue&type=template&id=70703fe3"
import script from "./sorting-control.vue?vue&type=script&lang=js"
export * from "./sorting-control.vue?vue&type=script&lang=js"
import style0 from "./sorting-control.vue?vue&type=style&index=0&id=70703fe3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports